var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TextContainer',{attrs:{"src":_vm.src,"content":_vm.content,"id":_vm.id,"orientation":_vm.orientation,"title":_vm.title,"imageFooter":_vm.imageFooter,"highlightedImage":_vm.highlightedImage},on:{"showmodal":function($event){return _vm.$emit('showmodal')}}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9323d46","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BigTextContainer.vue
// module id = null
// module chunks = 